import { useAppSelector } from 'app/hooks';
import Text from 'components/inputs/text';
import {
  customerMatchesSearch,
  formatProjectType,
  formatSubmittedAt
} from 'pages/admin/system-selector-customers-helpers';
import { useMemo, useState } from 'react';

const TABLE_HEADERS = [
  'Submitted',
  'Name',
  'Email',
  'Phone',
  'Project Type',
  'Address',
  'Goals'
];

export default function SystemSelectorCustomersPage() {
  const { systemSelectorCustomers } = useAppSelector((state) => state.admin);
  const [searchQuery, setSearchQuery] = useState('');

  const filteredCustomers = useMemo(
    () =>
      systemSelectorCustomers.filter((customer) =>
        customerMatchesSearch(customer, searchQuery)
      ),
    [systemSelectorCustomers, searchQuery]
  );

  return (
    <div className='mx-auto flex max-w-[1600px] flex-col gap-5'>
      <div className='text-3xl font-bold text-gray-900'>
        System Selector Customers
      </div>

      <div className='flex items-end gap-3'>
        <div className='w-72'>
          <Text
            value={searchQuery}
            onChange={(v) => setSearchQuery(v)}
            placeholder='Search customers...'
            controlled
          />
        </div>
      </div>

      <div className='max-h-[65vh] overflow-auto'>
        <table className='min-w-full border-separate border-spacing-0 divide-y divide-gray-300'>
          <thead>
            <tr>
              {TABLE_HEADERS.map((header) => (
                <th
                  key={header}
                  scope='col'
                  className='sticky top-0 z-10 border-b border-gray-300 bg-gray-100 px-3 pb-3.5 pt-3.5 text-left text-sm font-semibold text-gray-900'
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className='divide-y divide-gray-200'>
            {filteredCustomers.map((customer) => (
              <tr key={customer.id} className='hover:bg-gray-50'>
                <td className='whitespace-nowrap px-3 py-3 text-sm text-gray-500'>
                  {formatSubmittedAt(customer.createdAt)}
                </td>
                <td className='whitespace-nowrap px-3 py-3 text-sm font-medium text-gray-900'>
                  {customer.name}
                </td>
                <td className='whitespace-nowrap px-3 py-3 text-sm text-gray-500'>
                  {customer.email}
                </td>
                <td className='whitespace-nowrap px-3 py-3 text-sm text-gray-500'>
                  {customer.phone ?? '—'}
                </td>
                <td className='whitespace-nowrap px-3 py-3 text-sm text-gray-500'>
                  {formatProjectType(customer.projectType)}
                </td>
                <td className='px-3 py-3 text-sm text-gray-500'>
                  <div
                    className='max-w-[16rem] truncate'
                    title={customer.homeAddress ?? undefined}
                  >
                    {customer.homeAddress ?? '—'}
                  </div>
                </td>
                <td className='px-3 py-3 text-sm text-gray-500'>
                  <div
                    className='max-w-[24rem] truncate'
                    title={customer.projectGoals ?? undefined}
                  >
                    {customer.projectGoals ?? '—'}
                  </div>
                </td>
              </tr>
            ))}
            {filteredCustomers.length === 0 && (
              <tr>
                <td
                  colSpan={TABLE_HEADERS.length}
                  className='py-8 text-center text-sm text-gray-400'
                >
                  No customers found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className='text-sm text-gray-400'>
        {filteredCustomers.length} customer
        {filteredCustomers.length !== 1 ? 's' : ''}
      </div>
    </div>
  );
}
